import axios from 'axios'

import interceptorRequest from './interceptor-request.js'
import interceptorResponse from './interceptor-response.js'

const baseUrl = process.env.VUE_APP_HTTP_ROOT_API || 'https://api.pitom.com.br/api/v1'
const baseUrlP84 = process.env.VUE_APP_HTTP_ROOT_API_P84 || 'https://api.pitom.com.br/api/p84/'

const baseURLRepasse = process.env.VUE_APP_HTTP_REPASSE_API || 'https://p84-repasse-api-dev-1030976260031.us-central1.run.app/v1'

const timeout = process.env.VUE_APP_HTTP_TIMEOUT || '60000'
const headers = {
  'Access-Control-Allow-Origin': '*',
  //"User-Agent": process.env.VUE_APP_HTTP_USER_AGENT,
  'Content-Type': process.env.VUE_APP_HTTP_CONTENT_TYPE || 'application/json',
  'Accept': process.env.VUE_APP_HTTP_ACCEPT || '*/*',
}

class Http {
  constructor() {
    this.httpInstance = axios.create();
  }

  httpInstance() {
    return this.httpInstance
  }

  getInstance() {
    return this.httpInstance
  }

  //#region Configurations
  setBaseURL(baseURL) {
    this.httpInstance.defaults.baseURL = baseURL
  }
  
  setTimeout(timeout) {
    this.httpInstance.defaults.timeout = timeout
  }

  setHeaders(headers) {
    this.httpInstance.defaults.headers = headers
  }

  setBearerToken(token) {
    this.httpInstance.defaults.headers['Authorization'] = `Bearer ${token}`
  }
  //#endregion
  
  //#region Http Methods
  get(url, config = {}) {
    return this.httpInstance.get(url, config)
  }

  post(url, data = {}, config = {}) {
    return this.httpInstance.post(url, data, config)
  }

  put(url, data = {}, config = {}) {
    return this.httpInstance.put(url, data, config)
  }

  patch(url, data = {}, config = {}) {
    return this.httpInstance.patch(url, data, config)
  }

  delete(url, config = {}) {
    return this.httpInstance.delete(url, config)
  }
  //#endregion

  //#region Interceptors
  useInterceptors() {
    this.httpInstance.interceptors.request.use(
      interceptorRequest.config,
      interceptorRequest.error
    )

    this.httpInstance.interceptors.response.use(
      interceptorResponse.response,
      interceptorResponse.error
    )
  }
  //#endregion
}

class Http84 {
  constructor() {
    this.httpInstance84 = axios.create();
  }

  httpInstance() {
    return this.httpInstance84
  }

  getInstance() {
    return this.httpInstance84
  }

  //#region Configurations
  setBaseURL(baseURL) {
    this.httpInstance84.defaults.baseURL = baseURL
  }

  getBaseURL() {
    return this.httpInstance84.defaults.baseURL
  }
  
  setTimeout(timeout) {
    this.httpInstance84.defaults.timeout = timeout
  }

  setHeaders(headers) {
    this.httpInstance84.defaults.headers = headers
  }

  setBearerToken(token) {
    this.httpInstance84.defaults.headers['Authorization'] = `Bearer ${token}`
  }
  //#endregion
  
  //#region Http Methods
  get(url, config = {}) {
    return this.httpInstance84.get(url, config)
  }

  post(url, data = {}, config = {}) {
    return this.httpInstance84.post(url, data, config)
  }

  put(url, data = {}, config = {}) {
    return this.httpInstance84.put(url, data, config)
  }

  patch(url, data = {}, config = {}) {
    return this.httpInstance84.patch(url, data, config)
  }

  delete(url, config = {}) {
    return this.httpInstance84.delete(url, config)
  }
  //#endregion

  //#region Interceptors
  useInterceptors() {
    this.httpInstance84.interceptors.request.use(
      interceptorRequest.config,
      interceptorRequest.error
    )

    this.httpInstance84.interceptors.response.use(
      interceptorResponse.response,
      interceptorResponse.error
    )
  }
  //#endregion
}

const http = new Http()
http.setBaseURL(baseUrl)
http.setTimeout(timeout)
http.setHeaders(headers)

const http84 = new Http84();
http84.setBaseURL(baseUrlP84);
http84.setTimeout(timeout);
http84.setHeaders(headers);

const httpRepasse = new Http84();
httpRepasse.setBaseURL(baseURLRepasse);
httpRepasse.setTimeout(timeout);
httpRepasse.setHeaders(headers);

export { http, http84, httpRepasse } 
